import React from 'react';
import { Link } from 'react-router-dom';
import InlineSVG from './InlineSVG';
import LazyImage from './LazyImage/LazyImage';

export default function CourseCard({ course }) {
  const { image, title, status, progress, slug } = course;
  return (
    <Link to={`/cursos/ver/${slug}`} className="course-card">
      <LazyImage alt={title} src={image} className="image-wrapper"/>
      <section>
        <strong>{title}</strong>
        <div className="progress-bar">
          <span style={{ width: progress }} />
        </div>
        {status === 'started'
          ? <p className="continuar-assistindo">Continuar assistindo</p>
          : <p className="iniciar-curso">Iniciar curso <InlineSVG src={require("../img/icon-btn-play-transparent.svg")} /></p>
        }
        <img className="play-button" src={require('../img/icon-play-course.svg')} alt=""/>
      </section>
    </Link>
  )
}



// WEBPACK FOOTER //
// ./src/components/CourseCard.js